var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "reseller-login" }, [
    _c("div", { staticClass: "container" }, [
      _c("div", { staticClass: "row justify-center" }, [
        _c("div", { staticClass: "md:w-1/2 lg:w-5/12 w-full" }, [
          _c(
            "div",
            { staticClass: "lg:px-20" },
            [
              _vm._m(0),
              _vm._v(" "),
              _c(
                "el-form",
                {
                  staticClass: "mb-24",
                  attrs: {
                    loading: _vm.loading,
                    success: _vm.success,
                    error: _vm.server_error,
                    "button-class":
                      "btn btn-green btn-lg btn-rounded w-full mt-8 font-bold",
                    "submit-text": _vm.$t("forms.buttons.confirm_email")
                  },
                  on: { submit: _vm.submit }
                },
                [
                  _c("el-input", {
                    staticClass: "disabled mb-16",
                    attrs: {
                      disabled: true,
                      rules: "required",
                      label: _vm.$t("forms.labels.email")
                    },
                    model: {
                      value: _vm.formData.email,
                      callback: function($$v) {
                        _vm.$set(_vm.formData, "email", $$v)
                      },
                      expression: "formData.email"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "text-center" }, [
      _c("h1", { staticClass: "h4 mb-8" }, [_vm._v("Bevestig je email")]),
      _vm._v(" "),
      _c("p", { staticClass: "mb-40" }, [
        _vm._v(
          "Mattis nunc sed blandit libero volutpat sed. Amet volutpat consequat mauris nunc congue nisi vitae"
        )
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }